'use client'

import type { CouponCalloutText } from '@/components/client/shared/coupon-callout'
import { useTranslation } from '@/hooks/client/use-translation'
import { POSITION_SENTINEL } from '@/lib/prices/select'

import { effectiveSellerPrice, type PriceSellerData } from './price-section-types'
import { SellerRow } from './seller-row'

interface SellerListProps {
  sellers: PriceSellerData[]
  releaseSlug: string
  couponText: CouponCalloutText
}

export const SellerList = ({ sellers, releaseSlug, couponText }: SellerListProps) => {
  const { t } = useTranslation()
  const sorted = [...sellers].sort(
    (a, b) => (a.price > 0 ? effectiveSellerPrice(a) : Infinity) - (b.price > 0 ? effectiveSellerPrice(b) : Infinity)
  )
  const priced = sorted.filter((seller) => seller.price > 0)
  const lowest =
    priced.length > 1 && effectiveSellerPrice(priced[0]) < effectiveSellerPrice(priced[1]) ? priced[0] : null
  const featured = [...sorted]
    .filter((seller) => seller.sellerPosition != null && seller.sellerPosition < POSITION_SENTINEL)
    .sort((a, b) => (a.sellerPosition ?? POSITION_SENTINEL) - (b.sellerPosition ?? POSITION_SENTINEL))[0]
  return (
    <div
      id="seller-offers"
      data-seller-offers
      className="mt-5 scroll-mt-28 overflow-hidden rounded-2xl border border-navy-10 bg-white shadow-sm"
    >
      {sorted.map((seller) => (
        <SellerRow
          key={seller.sellerId}
          seller={seller}
          featured={sorted.length > 1 && seller.sellerId === featured?.sellerId}
          lowestPrice={seller.sellerId === lowest?.sellerId}
          releaseSlug={releaseSlug}
          couponText={couponText}
        />
      ))}
      {!sorted.length && (
        <p className="p-5 text-sm text-navy-60">
          {t('product.purchase.noOffers', 'No offers are available for this configuration.')}
        </p>
      )}
    </div>
  )
}
